import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { previewSlides } from '../data/content';
export function PagePreview() {
  const [index, setIndex] = useState(0);
  const slide = previewSlides[index];
  const go = (direction: -1 | 1) => {
    setIndex(prev => (prev + direction + previewSlides.length) % previewSlides.length);
  };
  return <section className="w-full bg-cream-200 px-4 py-20" data-id="element-116" data-mp="2u1s8tlgq7r2t">
      <div className="mx-auto max-w-5xl" data-id="element-117" data-mp="2z1wnr71zkdqx">
        <div className="text-center" data-id="element-118" data-mp="2z0ll5aka1c1e">
          <Eyebrow data-id="element-119" data-mp="2z3rb0s0qchy6">Sbircia il materiale</Eyebrow>
          <h2 className="mt-4 font-display text-[28px] font-black leading-tight tracking-[-0.015em] text-ink sm:text-[36px]" data-id="element-120" data-mp="334kyxle69wr2">
            Guarda le pagine <span className="italic text-brand" data-id="element-121" data-mp="380idpn9sev1q">dall&apos;interno.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-lg font-sans text-[13px] leading-relaxed text-ink-soft" data-id="element-122" data-mp="18rblxjmf3t42">
            Pagine reali del pacchetto, nella stessa risoluzione in cui le riceverai: pronte da
            stampare senza ritocchi.
          </p>
        </div>

        <div className="mt-10 grid items-center gap-10 lg:grid-cols-[minmax(0,1fr)_320px]" data-id="element-123" data-mp="1udx9p7k16ifa">
          <div className="relative mx-auto w-full max-w-md" data-id="element-124" data-mp="1qc28e323o51i">
            <img key={slide.image} src={slide.image} alt={`Anteprima della scheda: ${slide.title}`} className="mx-auto max-h-[560px] w-auto max-w-full rounded-xl border border-cream-300 bg-white object-contain shadow-lift" data-id="element-125" data-mp="1qa7oms2keiz0" />

            <button type="button" onClick={() => go(-1)} aria-label="Scheda precedente" className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-cream-300 bg-white p-2 text-ink shadow-card transition-colors duration-150 ease-out hover:bg-cream-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-126" data-mp="2e01z52zevvg3">
              <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="u68pl3zfenkp" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Scheda successiva" className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rounded-full border border-cream-300 bg-white p-2 text-ink shadow-card transition-colors duration-150 ease-out hover:bg-cream-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-128" data-mp="z53fsqzq3eeu">
              <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="g6r3wxhffqfk" />
            </button>

            <p className="mt-4 text-center font-sans text-[11px] font-semibold tabular-nums tracking-[0.2em] text-ink-muted" data-id="element-130" data-mp="2fcmgv363xam">
              {index + 1} / {previewSlides.length}
            </p>
          </div>

          <div className="lg:pl-2" data-id="element-131" data-mp="3olrf8fsg6kgl">
            <p className="font-sans text-[10px] font-bold uppercase tracking-[0.2em] text-brand" data-id="element-132" data-mp="3omt17fb04rd3">
              {slide.tag}
            </p>
            <h3 className="mt-3 font-display text-2xl font-black leading-tight text-ink" data-id="element-133" data-mp="39z2fqdy747a7">
              {slide.title}
            </h3>
            <p className="mt-3 font-sans text-[13px] leading-relaxed text-ink-soft" data-id="element-134" data-mp="351amngltef4f">
              {slide.text}
            </p>

            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-135" data-mp="3jyt92cb0sg8p">
              {previewSlides.map((item, i) => <li key={item.image} data-id="element-136" data-mp="3f0i2qbjxonv8" data-mpi={i}>
                  <button type="button" onClick={() => setIndex(i)} aria-label={`Vai alla pagina ${i + 1}: ${item.title}`} aria-current={i === index} className={`h-14 w-11 overflow-hidden rounded-md border bg-white transition-[border-color,opacity] duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${i === index ? 'border-brand opacity-100' : 'border-cream-300 opacity-60 hover:opacity-100'}`} data-id="element-137" data-mp="3sxofnphz7scj">
                    <img src={item.image} alt="" className="h-full w-full object-cover" data-id="element-138" data-mp="2505k98spagzt" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}